package audio

class WebSoundEngine : SoundEngine {
    private val ctx: AudioContext = js("new AudioContext()")
    private val masterGain = ctx.createGain().also {
        it.gain.value = 0.4
        it.connect(ctx.asDynamic().destination)
    }

    override var enabled: Boolean = true

    override fun playMove() = tone(frequency = 220.0, durationMs = 40.0, gainPeak = 0.08, type = "square")
    override fun playRotate() = tone(frequency = 330.0, durationMs = 50.0, gainPeak = 0.1, type = "sine")
    override fun playSoftDrop() = tone(frequency = 180.0, durationMs = 30.0, gainPeak = 0.06, type = "square")
    override fun playHardDrop() = tone(frequency = 120.0, durationMs = 80.0, gainPeak = 0.25, type = "square")
    override fun playHold() = tone(frequency = 280.0, durationMs = 60.0, gainPeak = 0.1, type = "triangle")
    override fun playLock() = tone(frequency = 160.0, durationMs = 60.0, gainPeak = 0.15, type = "square")

    override fun playLineClear(lines: Int) {
        val freqs = when (lines) {
            1    -> listOf(440.0)
            2    -> listOf(440.0, 550.0)
            3    -> listOf(440.0, 550.0, 660.0)
            else -> listOf(523.0, 659.0, 784.0, 1047.0) // C5 chord arpeggio
        }
        freqs.forEachIndexed { i, f ->
            tone(frequency = f, durationMs = 120.0, gainPeak = 0.2,
                 type = "sine", delayMs = i * 40.0)
        }
    }

    override fun playLevelUp() {
        listOf(523.0, 659.0, 784.0, 1047.0).forEachIndexed { i, f ->
            tone(frequency = f, durationMs = 100.0, gainPeak = 0.18,
                 type = "sine", delayMs = i * 60.0)
        }
    }

    override fun playGameOver() {
        listOf(440.0, 350.0, 260.0).forEachIndexed { i, f ->
            tone(frequency = f, durationMs = 200.0, gainPeak = 0.2,
                 type = "sawtooth", delayMs = i * 180.0)
        }
    }

    private fun tone(
        frequency: Double,
        durationMs: Double,
        gainPeak: Double,
        type: String = "sine",
        delayMs: Double = 0.0,
    ) {
        if (!enabled) return
        val now = ctx.currentTime + delayMs / 1000.0
        val dur = durationMs / 1000.0

        val gain = ctx.createGain()
        gain.gain.setValueAtTime(0.0, now)
        gain.gain.linearRampToValueAtTime(gainPeak, now + dur * 0.1)
        gain.gain.exponentialRampToValueAtTime(0.0001, now + dur)
        gain.connect(masterGain)

        val osc = ctx.createOscillator()
        osc.type = type
        osc.frequency.setValueAtTime(frequency, now)
        osc.connect(gain)
        osc.start(now)
        osc.stop(now + dur + 0.01)
    }
}
